module.exports = __webpack_public_path__ + "img/EUR.f28c1c41.svg";